module.exports = __webpack_public_path__ + "img/emoji-wink-fill.3601171b.svg";